import { render, staticRenderFns } from "./text-with-button.vue?vue&type=template&id=2c57e741&scoped=true&"
import script from "./text-with-button.vue?vue&type=script&lang=js&"
export * from "./text-with-button.vue?vue&type=script&lang=js&"
import style0 from "./text-with-button.vue?vue&type=style&index=0&id=2c57e741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57e741",
  null
  
)

export default component.exports